import React from "react";

/**
 * テキスト装飾プロパティ
 */
type TextDecorationProps = {
  /** 文章要素 */
  sentences?: LineElement[];
};

/** 文章要素 */
type LineElement = {
  /** テキスト */
  text: string;
  /** 適用するスタイル */
  style?: string[];
  /** 改行無しフラグ */
  isInline?: boolean;
};

/**
 * テキスト装飾コンポーネント
 * @param props テキスト装飾プロパティ
 */
const TextDecoration: React.FC<TextDecorationProps> = (props) => {
  if (!props.sentences) {
    return null;
  }

  return (
    <React.Fragment>
      {props.sentences.map((lineElement: LineElement | string, index) => {
        const style = typeof lineElement === "string" ? "" : lineElement.style?.join(" ");
        const text =  typeof lineElement === "string" ? lineElement : lineElement.text;
        const isInline = typeof lineElement === "string" ? false : lineElement.isInline;
        return (
          <React.Fragment key={index}>
            <span className={`${style || ""}`}>{text}</span>
            {isInline ? "" : <br />}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default TextDecoration;
